import React, { useState, useEffect } from 'react';
import ReactTable from 'react-table'; // Deprecated, consider upgrading to React-Table v7 or later
import { Row, Col, Button, Card } from 'reactstrap'
import { connect } from "react-redux";

import FetchAllAccountDetailsService from '../../../../../../Service/OPSServices/AccountDetailsService/FetchAllAccountDetailsService';
import CustomModal from '../../../../../Components/Modals/CustomModal';
import UpdateExistingAccountDetails from './Component/UpdateExistingAccountDetails';
import AddNewAccountsDetails from './Component/AddNewAccountsDetails';

function AccountDetailsMainPage(props) {
  const [userData, setUserData] = useState([]);
  const [searchText, setSearchText] = useState('');
  const [updateAccountDetailsPopup, setupdateAccountDetailsPopup] = useState(false)
  const [selectedAccountDetails, setSelectedAccountDetails] = useState(null);
  const [selectedAccountDetailsId, setSelectedAccountDetailsId] = useState(null);
  const [accountTypes, setAccountTypes] = useState('')
  const [createAccountDetailsPopup, setCreateAccountDetailsPopup] = useState(false)
  const [addressText, setAddressText] = useState('');
  const [fullAddressPopup, setFullAddressPopup] = useState(false);
  const [integerId, setIntegerId] = useState()
  const [storeData, setStoreData] = useState()
  const [simpliusersList, setSimpliusersList] = useState()




  useEffect(() => {
    FetchAllAccountDetailsService(props.token).then((res) => {
      if (res) {
        console.log(res);
        setUserData(res.agenciesData);
        setAccountTypes(res.accountTyps)
        setStoreData(res.store_List)
        setSimpliusersList(res.simpliusers)
      }
    });
  }, []);

  const handleAccountDetails = (accountData) => {
    setSelectedAccountDetails(accountData);
    setSelectedAccountDetailsId(accountData.id);
    console.log(accountData)
    setupdateAccountDetailsPopup(true)
  }

  const handleAddress = (address) => {
    setAddressText(address);
    setFullAddressPopup(true);
  };

  const truncateAddress = (str, numWords) => {
    const words = (str || '').split(' ');
    return words.length > numWords ? words.slice(0, numWords).join(' ') + ' ...' : str;
  };


  const handleCloseUpdateAccountDetailsPopup = (tasklist) => {
    setSelectedAccountDetails(tasklist.agenciesData)
    setUserData(tasklist.agenciesData)
    setupdateAccountDetailsPopup(false)
    setCreateAccountDetailsPopup(false)
  }



  const Column = [
    {
      Header: 'Account Type',
      accessor: 'Account_Types',
      Cell: (cellInfo) => (
        <div className="d-flex justify-content-center w-100">
          <p className="mb-0">{cellInfo.value}</p>
        </div>
      ),
    },
    {
      Header: 'Account Name',
      accessor: 'name',
      Cell: (cellInfo) => (
        <div className="d-flex justify-content-center w-100">
          <p onClick={() => handleAccountDetails(cellInfo.original)}
          title={cellInfo.value}
            className="mb-0 cursor-pointer comment-paragraph">{cellInfo.value}</p>
        </div>
      ),
    },
    {
      Header: 'Contact',
      accessor: 'admin',
      Cell: (cellInfo) => (
        <div className="d-flex justify-content-center w-100">
          <p title={cellInfo.value} className="mb-0 comment-paragraph">{cellInfo.value}</p>
        </div>
      ),
    },
    {
      Header: 'Email',
      accessor: 'email',
      Cell: (cellInfo) => (
        <div className="d-flex justify-content-center w-100">
          <p title={cellInfo.value} className="mb-0 comment-paragraph">{cellInfo.value}</p>
        </div>
      ),
    },
    {
      Header: 'Phone',
      accessor: 'phone',
      Cell: (cellInfo) => (
        <div className="d-flex justify-content-center w-100">
          <p className="mb-0 comment-paragraph">{cellInfo.value}</p>
        </div>
      ),
    },
    {
      Header: 'Pricing Plan',
      accessor: 'pricingPlan',
      Cell: (cellInfo) => (
        <div className="d-flex justify-content-center w-100">
          <p className="mb-0 ">{cellInfo.value}</p>
        </div>
      ),
    },
    {
      Header: 'Start Date',
      accessor: 'startDate',
      Cell: (cellInfo) => (
        <div className="d-flex justify-content-center w-100">
          <p className="mb-0 ">{cellInfo.value}</p>
        </div>
      ),
    },
    // {
    //   Header: 'Address',
    //   accessor: 'address',
    //   Cell: ({ value }) => (
    //     <div
    //       className="address-text"
    //       onClick={() => handleAddress(value)}
    //     >
    //       <p className="mb-0 comment-paragraph">{truncateAddress(value, 20)}</p>
    //     </div>
    //   ),
    // },
  ];

  const filterUserData = userData && userData.filter((row) => {
    const Name = (row.name || '').toLowerCase();
    const AccountTypes = (row.Account_Types || '').toString().toLowerCase();
    const Address = (row.address || '').toString().toLowerCase();
    const Admin = (row.admin || '').toString().toLowerCase();
    const Email = (row.email || '').toString().toLowerCase();
    const Phone = (row.phone || '').toString().toLowerCase();
    const PricingPlan = (row.pricingPlan || '').toString().toLowerCase();
    // const StartDate = (row.startDate || '').toString().toLowerCase();

    return (
      AccountTypes.includes(searchText.toLowerCase()) ||
      Name.includes(searchText.toLowerCase()) ||
      Address.includes(searchText.toLowerCase()) ||
      Admin.includes(searchText.toLowerCase()) ||
      Email.includes(searchText.toLowerCase()) ||
      Phone.includes(searchText.toLowerCase()) ||
      PricingPlan.includes(searchText.toLowerCase()) 
      // StartDate.includes(searchText.toLowerCase())
    );
  });

  return (
    <>
      <Row>
        <Col>
          <h3>Accounts</h3>
        </Col>
      </Row>
      <Row className="align-items-center mb-3">
        <Col md={6}>
          <input
            type="text"
            placeholder="Search..."
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
            className="form-control w-75"
          />
        </Col>
        <Col md={6} className="text-md-right"
          onClick={() => setCreateAccountDetailsPopup(true)} >
          <Button className="btn-background-color float-md-right">
            Create
          </Button>
        </Col>
      </Row>
      <Row>
        <Col md={12}>
          <ReactTable
            data={filterUserData}
            columns={Column}
            className="-fixed -highlight -striped"
            getTheadProps={() => {
              return {
                style: {
                  overflowY: "hidden",
                  background: "#B1FA63",
                  // color: "#243837",
                },
              };
            }}
            defaultPageSize={10}
            noDataText="Loading Account Details..."
          />
        </Col>
      </Row>
      <CustomModal
        // header={'Created by'{agenciesData.fullName} 'at' {agenciesData.createdAt}}
        header={
          <h4 className='ml-1'><b>Account Details</b></h4>
        }

        isOpen={updateAccountDetailsPopup}
        toggle={() => { setupdateAccountDetailsPopup(!updateAccountDetailsPopup); }}
        size={"xl"}
        className='curve-popup updateAccountDetailsPopup-bg'
      >
        <UpdateExistingAccountDetails
          handleCloseUpdateAccountDetailsPopup={handleCloseUpdateAccountDetailsPopup}
          accountDetails={selectedAccountDetailsId}
          action={false}
          setUserData={setUserData}
          accountTypes={accountTypes}
          storeData={storeData}
          simpliusersList={simpliusersList}

        />
      </CustomModal>
      <CustomModal
        header={"Create Account"}
        isOpen={createAccountDetailsPopup}
        toggle={() => { setCreateAccountDetailsPopup(!createAccountDetailsPopup); }}
        size={"lg"}
        className='curve-popup'
      >
        <AddNewAccountsDetails
          handleCloseUpdateAccountDetailsPopup={handleCloseUpdateAccountDetailsPopup}
          accountDetails={selectedAccountDetails}
          accountTypes={accountTypes}

        />
      </CustomModal>
      <CustomModal
        header={"Address"}
        isOpen={fullAddressPopup}
        toggle={() => setFullAddressPopup(!fullAddressPopup)}
        size={"md"}
        className='curve-popup'
      >
        <p>{addressText}</p>
      </CustomModal>


    </>
  );
}
const mapStateToProps = (state) => {
  return {
    token: state.loggedUser.token,
    accessLevel: state.loggedUser.accessLevel,
    status: state.loggedUser.status,
    error: state.loggedUser.error,
    adProfiles: state.accountOverview.landing.adProfiles,
  };
};

export default connect(mapStateToProps)(AccountDetailsMainPage);
